module.exports = __webpack_public_path__ + "static/images/styles/images/button-small/bsm-secondary-hover-bg.f8004862.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/button-small/bsm-secondary-hover-bg.png
// module id = 3609
// module chunks = 11